import { OptionalDiscountSchema, RawDiscount } from '@features/state';

export type DiscountLine = {
  discount?: unknown;
  price?: { amount: number } | null;
  count: number;
};

type ParsedDiscountLine = Omit<DiscountLine, 'discount'> & { discount?: RawDiscount | null };

const sumAmounts = (
  lines: ParsedDiscountLine[],
  pickPrice: (discount: RawDiscount) => { amount: number }
) =>
  lines.reduce(
    (total, { discount, price, count }) =>
      total + (discount ? pickPrice(discount).amount : price?.amount ?? 0) * count,
    0
  );

export const sumDiscounts = (rawLines: DiscountLine[]): RawDiscount | undefined => {
  const lines: ParsedDiscountLine[] = rawLines.map((line) => ({
    ...line,
    discount: OptionalDiscountSchema.parse(line.discount),
  }));
  const firstDiscount = lines.find(({ discount }) => discount)?.discount;

  if (!firstDiscount) {
    return undefined;
  }

  return {
    name: firstDiscount.name,
    standard_price: {
      ...firstDiscount.standard_price,
      amount: sumAmounts(lines, (discount) => discount.standard_price),
    },
    discounted_price: {
      ...firstDiscount.discounted_price,
      amount: sumAmounts(lines, (discount) => discount.discounted_price),
    },
  };
};
